export enum ItemType {
    MYTRIPS = 'myTrips',
    MYPASTTRIPS = 'myPastTrips',
    PLAN = 'plan',
    LONGMOVER='longMover'
}

export enum SummaryType {
    MYACTIVITIES = 'myActivities',
    MYSCHEDULEDACTIVITIES = 'myScheduledActivities',
    MYPASTACTIVITIES = 'myPastActivities' 
}